var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.666,
    cy: 15.4043,
    r: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6195_5041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.084 9.07617H8.24805C7.37396 9.07617 6.66602 9.78851 6.66602 10.6582V20.1504C6.66602 21.0253 7.37916 21.7324 8.24805 21.7324H23.084C23.9508 21.7324 24.666 21.0282 24.666 20.1504V10.6582C24.666 9.79005 23.9609 9.07617 23.084 9.07617ZM22.8624 10.1309C22.5392 10.4524 16.9767 15.9855 16.7847 16.1766C16.4859 16.4754 16.0886 16.6399 15.666 16.6399C15.2434 16.6399 14.8462 16.4754 14.5464 16.1756C14.4172 16.0471 8.91612 10.575 8.4696 10.1309H22.8624ZM7.7207 19.9357V10.8735L12.2783 15.4071L7.7207 19.9357ZM8.47027 20.6777L13.0261 16.1509L13.8016 16.9223C14.2996 17.4204 14.9617 17.6946 15.666 17.6946C16.3703 17.6946 17.0324 17.4204 17.5295 16.9233L18.306 16.1509L22.8618 20.6777H8.47027ZM23.6113 19.9357L19.0537 15.4071L23.6113 10.8735V19.9357Z",
    fill: "#0B2C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6195_5041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6.66602 6.4043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFooter);
export default __webpack_public_path__ + "static/media/email-footer.8b5fdcf8c1570a28dedb27041c541fc6.svg";
export { ForwardRef as ReactComponent };